type JsonLdProps = {
  data: Record<string, unknown> | null | undefined;
};

/** Renders a JSON-LD script tag. Escapes `<` to avoid breaking out of the script element. */
export const JsonLd = ({ data }: JsonLdProps) => {
  if (!data) return null;
  const json = JSON.stringify(data).replace(/</g, "\\u003c");
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />;
};
